import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import { RanaButton, RanaHeading, RanaModal } from "@nens/ranalib";

import AddModelSchemaCatalogueSrc from "@/images/add-model-schema-catalogue.svg?url";
import UpdateModelSchemaCatalogueSrc from "@/images/update-model-schema-catalogue.svg?url";

import { SubmitType } from "../project-file-model-schema-to-catalogue";

type ModelSchemaSubmitOptionsProps = {
  setSubmitType: (submitType: SubmitType) => void;
  isOpen: boolean;
  onCloseAll: () => void;
};

export const ModelSchemaSubmitOptions = ({
  setSubmitType,
  isOpen,
  onCloseAll,
}: ModelSchemaSubmitOptionsProps) => {
  return (
    <RanaModal
      topBar={
        <FormattedMessage
          id="projectfile.submit_schematisation"
          defaultMessage="Submit to catalogue"
        />
      }
      isOpen={isOpen}
      onClose={onCloseAll}
      maxW="3xl"
      h="fit"
    >
      <Box>
        <Text>
          <FormattedMessage
            id="projectfile.submit_schematisation_description"
            defaultMessage="Submit your model schematisation to the catalogue by choosing one of the options below."
          />
        </Text>

        <Flex my={4} gap={4}>
          <SubmitTypeBox
            onClick={() => setSubmitType("add")}
            imageSrc={AddModelSchemaCatalogueSrc}
            title={
              <FormattedMessage
                id="projectfile.add_a_new_model_schema"
                defaultMessage="Add a new entry to the catalogue"
              />
            }
            description={
              <FormattedMessage
                id="projectfile.add_a_new_model_schema_description"
                defaultMessage="Adding a new model schematisation to the catalogue makes it possible for your colleagues to use it in their projects. This will create a new entry in the catalogue."
              />
            }
          />
          <SubmitTypeBox
            onClick={() => setSubmitType("update")}
            imageSrc={UpdateModelSchemaCatalogueSrc}
            title={
              <FormattedMessage
                id="projectfile.update_existing_model_schema"
                defaultMessage="Update an existing entry in the catalogue"
              />
            }
            description={
              <FormattedMessage
                id="projectfile.update_existing_model_schema_description"
                defaultMessage="By updating an existing model schematisation in the catalogue it will be saved as a new revision. This will update the existing entry in the catalogue."
              />
            }
          />
        </Flex>
      </Box>
    </RanaModal>
  );
};

const SubmitTypeBox = ({
  onClick,
  imageSrc,
  title,
  description,
}: {
  onClick: () => void;
  imageSrc: string;
  title: ReactNode;
  description: ReactNode;
}) => {
  return (
    <RanaButton
      onClick={onClick}
      cursor="pointer"
      borderWidth="base"
      p={4}
      w="full"
      variant="tertiary"
      flexDirection="column"
      gap={2}
      whiteSpace="wrap"
      textAlign="start"
      h="auto"
    >
      <Box flexShrink={0} w="full" h={44} rounded="base" overflow="hidden" mb={2}>
        <Image w="full" h="full" objectFit="cover" objectPosition="center" src={imageSrc} />
      </Box>
      <RanaHeading type="h4">{title}</RanaHeading>
      <Text h="full" fontWeight="300" color="brand.deep_sea">
        {description}
      </Text>
    </RanaButton>
  );
};
